import { Controller } from '@hotwired/stimulus';

// Fills the discount absolute value from the selected product bundle's online total price.
export default class extends Controller {
  static targets = ['value', 'button', 'reductionType', 'targetType', 'productBundle'];
  static values = { urlTemplate: String, labelTemplate: String };

  connect() {
    this.bundlePrice = null;
    this.loadedBundleId = null;
    this.refresh = this.refresh.bind(this);
    this.element.addEventListener('change', this.refresh);
    this.refresh();
  }

  disconnect() {
    this.element.removeEventListener('change', this.refresh);
  }

  async refresh() {
    if (!this.hasButtonTarget) return;

    const show = this.canFetch();
    this.buttonTarget.hidden = !show;
    if (!show) {
      this.bundlePrice = null;
      this.loadedBundleId = null;
      this.updateLabel();
      return;
    }

    await this.loadPrice();
    this.updateLabel();
  }

  async fetchPrice(event) {
    event.preventDefault();
    if (!this.canFetch()) return;

    await this.loadPrice();
    this.updateLabel();
    if (this.bundlePrice == null || !this.hasValueTarget) return;

    this.valueTarget.value = this.bundlePrice;
    this.valueTarget.dispatchEvent(new Event('input', { bubbles: true }));
  }

  async loadPrice() {
    const bundleId = this.productBundleTarget.value;
    if (bundleId === this.loadedBundleId && this.bundlePrice != null) return;

    const url = this.urlTemplateValue.replace('__ID__', bundleId);
    const response = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!response.ok) {
      this.bundlePrice = null;
      this.loadedBundleId = null;
      return;
    }

    const data = await response.json();
    this.bundlePrice = data.value ?? null;
    this.loadedBundleId = this.bundlePrice == null ? null : bundleId;
  }

  updateLabel() {
    if (!this.hasButtonTarget || !this.hasLabelTemplateValue) return;

    const value = this.bundlePrice || '…';
    this.buttonTarget.textContent = this.labelTemplateValue.replace('%{value}', value);
  }

  canFetch() {
    const absoluteSelected = this.reductionTypeTargets.some(
      (input) => input.checked && input.value === 'absolute'
    );
    const bundleTargetSelected = this.targetTypeTargets.some(
      (input) => input.checked && input.value === 'product_bundle'
    );
    const bundleSelected = this.hasProductBundleTarget && this.productBundleTarget.value !== '';

    return absoluteSelected && bundleTargetSelected && bundleSelected;
  }
}
